import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollOnHashMount() {
  const location = useLocation();

  // ページ遷移時にトップへスクロール
  useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  // ハッシュがある場合はその要素へスクロール
  useEffect(() => {
    if (location.hash) {
      const hash = location.hash.replace("#", "");
      const el = document.getElementById(hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location.hash]);

  return null;
}
